<template>
  <div name="swimming">
    <header class="inner-head border-transparent">
      <div class="flex justify-between">
        <h2 class="inner-head-title">Toolbox</h2>

             <UpgradeOption v-if="shouldShowUpgrade" @pressed="showUpgrade()">
        </UpgradeOption>
      </div>
    </header>

    <div class="header-subnav-holder">

      <button
        v-for="path in tabsList"
        :key="path.id"
        type="button"
        class="header-subnav focus:outline-none"
        @click="showPath(path)"
        v-bind:class="[selectedPath.id === path.id ? 'selected' : '']"
      >
        {{ path.name }}
      </button>
    </div>
  
    <router-view class="pb-24" />

        <UpgradeModal
      v-if="showUpgradeModal"
      @close="showUpgrade()"
      :area="'Resource Library'"
    ></UpgradeModal>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { upgradeMixin } from "@/mixins/upgradeMixin.js";

const UpgradeModal = () => import("@/components/upgrade/UpgradeModal.vue");
const UpgradeOption = () => import("@/components/upgrade/UpgradeOption.vue");

export default {
  name: "toolbox",
    mixins: [upgradeMixin],
  props: [],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    showForSchool() {
      return this.currentUser.isSchool == true;
    },
    tabsList() {
      return this.tabs
    }
  },
  data() {
    return {
      tabs: [],
      selectedPath: {},
    };
  },
  created() {
  },
  mounted() {
     this.tabs = [
      {id: 1, name: "Pupils", path: "pupils"},
      {id: 2, name: "Crews", path: "crews"},
      {id: 3, name: "Clubs", path: "clubs"},

    ]

    this.selectedPath = this.tabs[0]
  },
  methods: {
    showPath(object) { 
      if (this.selectedPath.id === object.id) { return }
      this.selectedPath = object;
      this.$router.push("/toolbox/" + object.path);
     
    },
  },
  components: {
    UpgradeModal,
    UpgradeOption,
  },
};
</script>

<style scoped>
</style>